import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { DinnerReservation } from '@/types/dinner';

export const getDinnerReservations = async (
  email: string,
  year: number,
  month: number
): Promise<ApiResult<DinnerReservation[]>> => {
  const searchParams = new URLSearchParams({
    email: email,
    year: String(year),
    month: String(month),
  });

  const { status, result } = await callApi<DinnerReservation[]>(
    'dinner-reservations',
    'GET',
    searchParams,
    undefined,
    undefined,
    undefined,
    true
  );

  return { status, result: result ?? [] }; // null の場合、空配列を返す
};
